import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import Table, { Thead, Tbody, Tr, Th } from 'xpi-black-ui/Common/Table';
import Icon from 'xpi-black-ui/Base/Icon';

import useProposalCenterStore from 'store/ProposalCenter/state';

import WrapperActions, {
  CustomTooltip,
  CustomTd,
  StatusBullet,
  CancelOrder,
  CancelLoading,
  UnderlineText,
} from './styles';
import { SomaContext, SomaTooltip } from '@soma/react';

function UnwindingProposalTable({
  onOpenDetails,
  data = [],
  refetch,
}) {
  const { getCancelNewOperationsProposal } = useProposalCenterStore();

  const [isLoading, setIsLoading] = useState(false);
  const [cancelationId, setCancelationId] = useState(null);

  const onCancelProposal = (originalTicketId) => {
    setIsLoading(true);
    setCancelationId(originalTicketId);

    getCancelNewOperationsProposal(originalTicketId).then(() => {
      setIsLoading(false);
      toastr.success('Sucesso...', 'Operação cancelada com sucesso!');
      refetch();
    }).catch((error) => {
      toastr.error('Tente novamente', error?.response?.data?.mensagem || 'Falha ao cancelar a proposta');
      setIsLoading(false);
    });
  };

  const getCancelationButton = (originalTicketId) => {
    if (isLoading) {
      if (cancelationId === originalTicketId) {
        return (
          <CancelLoading size="sm" aria-label="Carregando" />
        );
      } else {
        return (<></>);
      }
    }
    return (
      <CancelOrder
        size="sm"
        icon="close"
        color="#FFF"
        onClick={() => onCancelProposal(originalTicketId)}
      />
    );
  };

  return (
    <Table>
      <Thead>
        <Tr align="center">
          <Th>Envio</Th>
          <Th>Tipo de Operação</Th>
          <Th>Cliente</Th>
          <Th>Ativo</Th>
          <Th>Estrutura</Th>
          <Th>Quantidade</Th>
          <Th>Entrada</Th>
          <Th>Encerramento</Th>
          <Th>
            <SomaContext inverse>
              <SomaTooltip placement="bottom-center" label="Comissão a dividir com base no preço referência do ativo objeto.">
                <UnderlineText>Comissão</UnderlineText>
              </SomaTooltip>
            </SomaContext>
          </Th>
          <Th>Status</Th>
          <Th>Ações</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data?.map(proposal => (
          <Tr key={`${proposal.unwindTicketId}`}>
            <CustomTd>{proposal.proposalDate}</CustomTd>
            <CustomTd>{proposal.operationType}</CustomTd>
            <CustomTd>{proposal.clientId}</CustomTd>
            <CustomTd>{proposal.asset.ticker}</CustomTd>
            <CustomTd>{proposal.structureName}</CustomTd>
            <CustomTd>{proposal.quantity}</CustomTd>
            <CustomTd>{proposal.acquisitionDate}</CustomTd>
            <CustomTd>{proposal.fixingDate}</CustomTd>
            <CustomTd>{(proposal.finalComission !== '-') ? proposal.finalComission : proposal.indicativeComission}</CustomTd>
            <CustomTd>
              <StatusBullet name={proposal.status}>{proposal.status}</StatusBullet>
            </CustomTd>
            <CustomTd>
              <WrapperActions>
                {proposal.operationType !== 'Nova Contratação' ? (
                  <Icon type="search" onClick={() => onOpenDetails(proposal)} />
                ) : (
                  proposal.status !== 'Cancelado' && getCancelationButton(proposal.originalTicketId)
                )}
              </WrapperActions>
            </CustomTd>
        </Tr>
        ))}
      </Tbody>
    </Table>
  );
}

export default React.memo(UnwindingProposalTable);

